import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PaymentMethodType } from '../../../types/Finance';

const initialState:PaymentMethodType = {
  description: '',
}

const paymentMethodSlice = createSlice({
  name: "paymentMethod",
  initialState,
  reducers: {
    setPaymentMethodData:(state, action:PayloadAction<PaymentMethodType>)=>({...state, ...action.payload}), 
    resetPaymentMethodData :()=>({...initialState})
  }
});

export const {setPaymentMethodData,resetPaymentMethodData} = paymentMethodSlice.actions

export default paymentMethodSlice.reducer